import type { LucideIcon } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

export interface DetailEmptyStateProps {
  icon: LucideIcon
  message: string
}

/** Dashed placeholder card shown in a detail panel when nothing is selected. */
export function DetailEmptyState({ icon: Icon, message }: DetailEmptyStateProps) {
  return (
    <Card className="bg-card/50 border-border border-dashed flex-1 flex items-center justify-center">
      <CardContent className="py-12 text-center">
        <Icon className="h-8 w-8 mx-auto text-muted-foreground/60 mb-3" />
        <p className="text-muted-foreground text-sm">{message}</p>
      </CardContent>
    </Card>
  )
}
